export let EmployeeDocs = [
  { code: 'OL', name: 'Offer Letter' },
  { code: 'CO', name: 'Contract' },
  { code: 'SC', name: 'Sodexo Contract' },
  { code: 'CC', name: 'Car Contract' },
  { code: 'PC', name: 'Employee Picture' },
  { code: 'MC', name: 'Medical Certificate' },
  { code: 'SP', name: 'Single Permit' },
  { code: 'RL', name: 'Resignation Letter' },
  { code: 'OO', name: 'Others' },
];

export let AssetsDocs = [
  { code: 'AP', name: 'Asset Pictures' },
  { code: 'AB', name: 'Asset Invoice' },
  { code: 'AW', name: 'Asset Warrenty' },
  { code: 'OO', name: 'Others' },
];

export let CategoryDocs = [
  { code: 'DB', name: 'Database Backup' },
  { code: 'IN', name: 'Invoice' },
  { code: 'OO', name: 'Others' },
];

export let UploadDocs = [
  { code: 'EU', name: 'Employees' },
  { code: 'CU', name: 'Contracts' },
  { code: 'LU', name: 'Leaves' },
  { code: 'AU', name: 'Assets' },
];
